<!--

	Inform parent that curriculum was pre-populated and parent should customize it for the needs of his/her child

-->
<template>
	<div>
		<Message :toast="toast" :portal="getPortalId()">
			<slot>
				<span v-tr="'curriculum_initialized'" />
			</slot>
		</Message>
		<Button :toast="toast" :portal="getPortalId('close')">
			<span v-tr="'curriculum_initialized_popup_close'" />
		</Button>
	</div>
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import type { SnotifyToast, SnotifyToastConfig } from "vue3-snotify";
import { MiaPlaza } from "@/Reinforced.Typings";
import Button from "./Shared/Button.vue";
import Message from "./Shared/Message.vue";
import { SNotification } from "./Shared/SNotification";

@Component({
	components: {
		Button,
		Message,
	},
})
export class CurriculumInitialized extends SNotification<MiaPlaza.Control.Vue.Notifications.ICurriculumInitialized> {
	protected getToastConstructor(): (config: SnotifyToastConfig) => SnotifyToast {
		return (config) => {
			return this.$snotify.info("…", config);
		};
	}

	protected getToastConfig(): SnotifyToastConfig {
		return {
			...this.getDefaultToastConfig(),
			buttons: [
				{
					// eslint-disable-next-line @typescript-eslint/unbound-method
					action: () => this.dismissOnServer().then(this.hide),
					text: this.getPortalId("close"),
				},
			],
		};
	}
}

export default toNative(CurriculumInitialized);
</script>
